module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '9dbbqvpd',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
